var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState, } from "react";
import Draggable from "react-draggable";
import Modal from "react-modal";
import { cashFilter, checkLogin, getIndexPCR, getMarketStatus, preOrdMarginCalculation, } from "src/apis/dashboard";
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_ENV } = process.env;
import OutsideClickHandler from "react-outside-click-handler";
import { getSliceLimitDummyData } from "src/apis/mock/data/get-slice-limit";
import MarginPlus from "src/components/activate-segment/margin-plus";
import StepNumberInput from "src/components/inputs/step-number-input";
import OrderSlicingModal from "src/components/modal/orderSlicing/order-slicing";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { closeBuySellModal, onModalOpenClose, openGuestLoginModal, } from "src/redux/reducers/modals";
import { captureBuySellAnalytics, captureCleverTabAnalytics, } from "src/utils/analytics";
import { COMMODITY_SEGMENT, EQUITY_SEGMENT, EXCHANGE_MAPPING, ORDER_SETTINGS, } from "src/utils/constant";
import { checkIsEmpty, convertNumberToShortText, getChangeAndChangePercentage, getDisplayTextFromExchange, getExchFromDisplayText, getExhangeColor, getExhangeTypeColor, getPreferences, getSegmentAndProductType, intComma, setPreferences, splitAndGetDetailsFromLongName, } from "src/utils/methods";
import { ToastUtils } from "src/utils/toast-utils";
import { heartBeatData, subscribeToData, unsubscribeDataBySubscriber, } from "src/utils/websocketwrapper";
import styles from "./buyform.module.scss";
import ChargesModal from "./charges-modal";
import IntraDayRegularBuyForm from "./intraday-form/intraday-regular-buyform";
import RegularStopLossBuyForm from "./regular-stoploss-buyform";
import VttBuyForm from "./vtt-buyform";
import MarketDepth from "src/components/market-depth/marketDepth";
import { marginUpdate } from "src/redux/reducers/non-persist";
import { closeDepthSocket } from "src/utils/depth-web-socket";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "src/utils/session-storage";
import { getDefaultDateFormat } from "../../../../utils/methods";
import SettingModal from "./form-setting/form-setting-modal";
import NoteModal from "./form-setting/note-modal";
// import { getAllowTmoDummyScriptData } from "src/apis/mock/data/get-allow-tmo-script";
import { Tooltip } from "react-bootstrap";
import Shimmer from "src/components/loader/shimmer";
import CommonLtpRenderer from "src/components/ltp-renderer/common-ltp-renderer";
import { DepthSnapToggleContext, PricePickerContext, } from "src/contexts/custom-context";
import { captureApxorEvent } from "src/utils/apxor";
import { v4 as uuid } from "uuid";
const componentName = "BuyForm";
const BuyFormNew = ({ scripData }) => {
    var _a, _b, _c, _d;
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const myPreferences = getPreferences();
    const [localScripData, setLocalScripData] = useState(Object.assign(Object.assign({}, scripData), { allowBktOrder: scripData.allowBktOrder == undefined ? true : scripData.allowBktOrder }));
    const dispatch = useAppDispatch();
    const { isBasket } = localScripData;
    const [sliceLimitData, setSliceLimitData] = useState(undefined);
    const [isFormValid, setFormValid] = useState(true);
    const [isLoading, setLoading] = useState(true);
    const [execute, setExecute] = useState(false);
    const [productType, setProductType] = useState("delivery"); //delivery , intraday
    const [formType, setFormType] = useState(localScripData.isBuy ? "BUY" : "SELL");
    const [timeType, setTimeType] = useState("regular"); //regular, stoploss, vtt
    const [dayType, setDayType] = useState("day"); //day, ioc, vtd,gtc
    const [validityDate, setValidityDate] = useState(() => moment().add(44, "days").format("YYYY-MM-DD"));
    const [disclosedQuantity, setDisclosedQuantity] = useState(0);
    const [afterMarketHours, setAfterMarketHours] = useState("N");
    const [marginPlus, setMarginPlus] = useState("N");
    const [disQtyErrorMessage, setDisQtyErrorMessage] = useState("");
    const [advanceToggle, setAdvanceToggle] = useState(false);
    const preOrdMarginCalculationRef = useRef(() => uuid());
    const [scripPriceData, setScripPriceData] = useState(localScripData);
    const [lotSize, setLotSize] = useState(1);
    const [maximumOrderModal, setMaximumOrderModal] = useState(false);
    const [nseBseShimmer, setNseBseShimmer] = useState(false);
    //const [chargesModal, setChargesModal] = useState(false);
    const [asmGsmModal, setAsmGsmModal] = useState(false);
    const [settingModal, setSettingModal] = useState(false);
    const [fetchSetting, setfetchSetting] = useState({
        qty: 0,
        productType: "delivery",
        priceType: "limit",
        key: "FNO",
    });
    const [userMarketEnabled, setUserMarketEnabled] = useState(getDataFromSession(SESSION_KEYS.USERMARKETENABLED) || {});
    // const [showQuote, setShowQuote] = useState(false);
    //for market depth hide and show
    const [toggleHideAndShow, setToggleHNS] = useState(myPreferences.buyform.depthPin);
    const closeDepthModalCallback = () => {
        setPickerData(Object.assign(Object.assign({}, picker), { modalToggleHideShow: !toggleHideAndShow }));
        setToggleHNS(!toggleHideAndShow);
    };
    //const setToggleHideAndShow = (modalStatus?): void => {
    //setToggleHNS(modalStatus ? modalStatus :picker.modalToggleHideShow);
    //setToggleHNS(!toggleHideAndShow);
    //};
    const [pinnedStatus, setPinnedStatus] = useState(myPreferences.buyform.depthPin);
    const [picker, setPickerData] = useState({
        price: 0,
        type: "market",
        modalToggleHideShow: myPreferences.buyform.depthPin
            ? myPreferences.buyform.depthPin
            : false,
    });
    const [depthToggle, setDepthToggle] = useState({
        show20: false,
        toggleShowQuotes: false,
        fullHeighModal: timeType,
    });
    const [charges, setCharges] = useState([]);
    // const [totalCharges, setTotalCharges] = useState<number>(0);
    // const showQuoteOnchange = useCallback((isChecked: boolean) => {
    //   setShowQuote(isChecked);
    // }, []);
    const renderTooltip = useCallback((toolname) => {
        return _jsx(Tooltip, Object.assign({ className: "" }, { children: toolname }));
    }, []);
    const useLatest = (value) => {
        const ref = useRef();
        ref.current = value;
        return ref;
    };
    const isStickyFormEnabled = useAppSelector((state) => {
        return state.app.isStickyForm;
    });
    const isOrderSetting = useAppSelector((state) => {
        return state.commonReducer.isOrderSetting;
    });
    const isGuestLoginModalOpen = useAppSelector((state) => state.modals.isGuestLoginModalOpen);
    const isStickyForm = useLatest(isStickyFormEnabled);
    const [marginDetail, setMarginDetail] = useState({
        AvailableMargin: 0,
        Margin: 0,
    });
    const [loadingMarginDetail, setLoadingMarginDetail] = useState(false);
    const [nseCode, setNseCode] = useState({ exchange: "", exchangeType: "", scripCode: 0 });
    const [bseCode, setBseCode] = useState({ exchange: "", exchangeType: "", scripCode: 0 });
    const [requestJson, setRequestJson] = useState({
        clientCode: clientCode,
        exchange: localScripData.exchange,
        exchangeType: localScripData.exchangeType,
        scripCode: localScripData.scripCode,
        transactionType: formType,
        atMarket: true,
        price: 0,
        stockQuantity: lotSize,
        disclosedQuantity: disclosedQuantity,
        isStopLoss: false,
        stopLossTriggerPrice: 0,
        isVtd: false,
        isIoc: false,
        isIntraDay: false,
        afterMarketHours: "N",
        validityTime: 0,
        orderFor: localScripData.orderFor,
        exchangeOrderId: localScripData.orderFor == "P"
            ? "0"
            : (_a = localScripData.orderData) === null || _a === void 0 ? void 0 : _a.ExchOrderID,
        iOrderValidity: 1,
        brokerOrderId: localScripData.orderFor == "P"
            ? ""
            : (_b = localScripData.orderData) === null || _b === void 0 ? void 0 : _b.BrokerOrderId,
    });
    const tokensData = useRef([]);
    const openFeedWsHeartBeat = useAppSelector((state) => {
        return state.openFeedWs.heartBeat;
    });
    const openFeedWsMsg = useAppSelector((state) => {
        if (localScripData.scripCode === 0) {
            return;
        }
        let update = state.openFeedWs.message;
        if (Array.isArray(update)) {
            update = update[0];
        }
        if ((update === null || update === void 0 ? void 0 : update.LastRate) != undefined &&
            state.openFeedWs.message &&
            state.openFeedWs.message.Token == localScripData.scripCode) {
            return update;
        }
        return undefined;
    });
    const buyFormRef = useRef(null);
    const buySellData = useAppSelector((state) => {
        return state.modals.buySellData;
    });
    const closeCallback = (isSuccess = false) => {
        var _a;
        if (isSuccess &&
            isStickyForm.current &&
            scripData.orderFor == "P" &&
            !((_a = scripData.openedFrom) === null || _a === void 0 ? void 0 : _a.includes("square-off")) &&
            !scripData.isBasket) {
            dispatch(marginUpdate(true));
        }
        else {
            dispatch(closeBuySellModal());
            dispatch(marginUpdate(true));
            //  return () => {
            closeDepthSocket(false);
            //  };
        }
    };
    // const getBrokergeChargesCallback = async (): Promise<void> => {
    //   setLoading(true);
    //   console.log("  getBrokergeChargesCallback();");
    //   let tempExchangeTxt;
    //   if (exchange == "NFO") {
    //     tempExchangeTxt = "NSE";
    //   } else if (exchange == "BFO") {
    //     tempExchangeTxt = "BSE";
    //   } else if (exchange == "CURR") {
    //     tempExchangeTxt = "NSE";
    //   } else {
    //     tempExchangeTxt = exchange;
    //   }
    //   let lotQty =
    //     segmentTypeObj.segmentType == EQUITY_SEGMENT
    //       ? requestJson.stockQuantity / lotSize
    //       : requestJson.stockQuantity;
    //   console.log(lotQty, "---");
    //   if (tempExchangeTxt && lotQty) {
    //     try {
    //       let planId = getDataFromSession(SESSION_KEYS.PLAN_ID);
    //       // let planId = "Ultra";
    //       if (!planId) {
    //         planId = "basic";
    //       }
    //       if (planId) {
    //         const response = await getBrokerageCalculation(
    //           segmentTypeObj.segmentType,
    //           segmentTypeObj.productType,
    //           productType,
    //           lotQty,
    //           formType == "BUY"
    //             ? requestJson.atMarket
    //               ? scripPriceData.lastTradePrice
    //               : Number(requestJson.price)
    //             : 0,
    //           formType == "SELL"
    //             ? requestJson.atMarket
    //               ? scripPriceData.lastTradePrice
    //               : Number(requestJson.price)
    //             : 0,
    //           planId,
    //           localScripData.scripCode,
    //           tempExchangeTxt
    //         );
    //         const localCharges: ChargeItemType[] = [];
    //         if (response.data.StatusCode == 200) {
    //           const dataObj = response.data.data[0];
    //           localCharges.push({
    //             dataLabel: "Turnover",
    //             dataValue: dataObj.Turnover,
    //           });
    //           localCharges.push({
    //             dataLabel: "Brokerage",
    //             dataValue: dataObj.Brokerage,
    //           });
    //           if (segmentTypeObj.segmentType == COMMODITY_SEGMENT) {
    //             localCharges.push({
    //               dataLabel: "CTT",
    //               dataValue: dataObj.CTT,
    //             });
    //           } else {
    //             localCharges.push({
    //               dataLabel: "STT",
    //               dataValue: dataObj.STT,
    //             });
    //           }
    //           localCharges.push({
    //             dataLabel: "Exchange Trnx Charge",
    //             dataValue: dataObj.ExhangeTrnxCharge,
    //           });
    //           localCharges.push({
    //             dataLabel: "Clearing Charges",
    //             dataValue: dataObj.ClearingCharges,
    //           });
    //           localCharges.push({
    //             dataLabel: "Stamp Duty",
    //             dataValue: dataObj.StampDuty,
    //           });
    //           localCharges.push({
    //             dataLabel: "GST",
    //             dataValue: dataObj.GST,
    //           });
    //           localCharges.push({
    //             dataLabel: "SEBI Charges",
    //             dataValue: dataObj.SEBICharges,
    //           });
    //           localCharges.push({
    //             dataLabel: "Total Charges",
    //             dataValue: dataObj.TotalCharges,
    //           });
    //           console.log(localCharges, "=====");
    //           setTotalCharges(dataObj.TotalCharges);
    //           setCharges(localCharges);
    //         } else {
    //           ToastUtils.error(response.data.StatusMessage);
    //         }
    //       }
    //     } catch (error) {
    //       console.error(error);
    //     } finally {
    //       setLoading(false);
    //     }
    //   }
    // };
    // console.log(buySellData, "buyselldata");
    // useEffect(() => {
    //   console.log(JSON.parse(JSON.stringify(localScripData)));
    // }, [localScripData]);
    //-----------------Handled Enter Key------------------------------------------------------
    // const button = document.querySelector("button");
    /*const enterKeyHandle = (event: WindowEventMap["keydown"]): void => {
      if (
        event.keyCode === 13 &&
        isFormValid &&
        disQtyErrorMessage == "" &&
        !isLoading
      ) {
        sendOrderRequestWrapper();
      }
    };
  
    useEffect(() => {
      window.addEventListener("keydown", enterKeyHandle);
      dispatch(
        onModalOpenClose({ componentName: componentName, currState: "open" })
      );
  
      return () => {
        window.removeEventListener("keydown", enterKeyHandle);
        dispatch(
          onModalOpenClose({ componentName: componentName, currState: "close" })
        );
      };
    }, []);*/
    //-----------------Handled Enter Key End----------------------------------------------------
    const [noteModal, setNoteModal] = useState(false);
    const toggleNoteModal = () => setNoteModal((noteModal) => !noteModal);
    //----enter key handler KK ------------------------------------------------------------------//
    const [hasFocusOnPopUp, setFocusOnPopUp] = useState(true);
    //keybord handle
    const executeRef = useRef(null);
    useEffect(() => {
        //keyboard listner
        const listener = (event) => {
            var _a;
            if ((event.code === "Enter" || event.code === "NumpadEnter") &&
                hasFocusOnPopUp) {
                event.preventDefault();
                (_a = executeRef === null || executeRef === void 0 ? void 0 : executeRef.current) === null || _a === void 0 ? void 0 : _a.click();
            }
        };
        document.addEventListener("keydown", listener);
        return () => {
            document.removeEventListener("keydown", listener);
            dispatch(onModalOpenClose({ componentName: componentName, currState: "close" }));
        };
    }, [hasFocusOnPopUp]);
    //-- end enter key value handler by KK ----------------------------------------------------------------------------//
    const toggleMaximumOrderModal = useCallback(() => {
        if (!maximumOrderModal) {
            setExecute(false);
            setFocusOnPopUp(false);
        }
        if (maximumOrderModal) {
            setFocusOnPopUp(true);
        }
        setMaximumOrderModal(!maximumOrderModal);
    }, [maximumOrderModal]);
    // const toggleChargesModal = (): void =>
    //   setChargesModal((chargesModal) => !chargesModal);
    const toggleAsmGsmModal = () => setAsmGsmModal((asmGsmModal) => !asmGsmModal);
    const toggleSettingModal = () => setSettingModal((settingModal) => !settingModal);
    const toggleAdvanceDD = () => setAdvanceToggle((advanceToggle) => !advanceToggle);
    const getMarketStatusCallback = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getMarketStatus();
            if (response.data.body.Status == 0) {
                const exchange = getExchFromDisplayText(localScripData.exchange);
                const exchangeType = localScripData.exchangeType;
                response.data.body.Data.forEach((singleElement) => {
                    if (singleElement.ExchType == exchangeType &&
                        exchange == singleElement.Exch) {
                        //console.log(singleElement.MarketStatus, "MArket Status");
                        if (singleElement.MarketStatus == "Open") {
                            setAfterMarketHours("N");
                        }
                        else {
                            setAfterMarketHours("Y");
                        }
                    }
                });
            }
        }
        catch (err) {
            console.error(err);
        }
    });
    const getMarginPDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // const response = await getMarginPlusDetails();
            // setMarginPlus(response.data.body.MTFOpted);
        }
        catch (error) {
            console.error("error ", error);
        }
    });
    useEffect(() => {
        setFocusOnPopUp(!settingModal);
    }, [settingModal]);
    useEffect(() => {
        getMarginPDetails();
        updateMarketEnabled();
        captureApxorEvent("orderform_opened", "");
    }, []);
    //------------Websocket start--------------------------------------------------------------------------------------------------------
    const sendWsMessage = (heartBeatMessage) => {
        const method1 = {
            Method: "MarketFeedV3",
            Operation: "Subscribe",
            ClientCode: clientCode,
            MarketFeedData: tokensData.current,
        };
        if (heartBeatMessage) {
            heartBeatData(method1, componentName, () => { });
        }
        else {
            subscribeToData(method1, componentName, () => { });
        }
    };
    useEffect(() => {
        // const cloneData: BuySellData = JSON.parse(JSON.stringify(localScripData));
        // setScripPriceData(cloneData);
        unsubscribeDataBySubscriber(componentName);
        tokensData.current = [
            {
                Exch: localScripData.exchange,
                ExchType: localScripData.exchangeType,
                ScripCode: localScripData.scripCode,
            },
        ];
        sendWsMessage(openFeedWsHeartBeat);
        //TODO commented for lajri testing
        // if (REACT_APP_ENV == "production") {
        //getMarketStatusCallback();
        // }
    }, [openFeedWsHeartBeat, localScripData]);
    const updateOptionChain = (update) => {
        const newScripDetails = Object.assign({}, scripPriceData);
        if (Array.isArray(update)) {
            update = update[0];
        }
        if ((update === null || update === void 0 ? void 0 : update.Details) === undefined &&
            (update === null || update === void 0 ? void 0 : update.OpenInterest) === undefined &&
            scripPriceData.scripCode == (update === null || update === void 0 ? void 0 : update.Token)) {
            newScripDetails.lastTradePrice = update.LastRate;
            newScripDetails.previousClose = update.PClose;
            setScripPriceData(newScripDetails);
        }
    };
    useEffect(() => {
        if (openFeedWsMsg) {
            updateOptionChain(openFeedWsMsg);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openFeedWsMsg]);
    //------------Websocket End--------------------------------------------------------------------------------------------------------
    // Fetching/Getting the API Data from Market Depth
    const getScripDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f, _g, _h;
        try {
            if (!scripData.lotSize || scripData.lotSize == 0) {
                setLotSize(0);
            }
            else {
                setLotSize(scripData.lotSize);
            }
            setLoading(true);
            let response = undefined;
            // if (segmentTypeObj.productType == CASH_PRODUCT) {
            //   response = await scriptDetailsForFOOrderV4(
            //     localScripData.exchange,
            //     localScripData.exchangeType,
            //     localScripData.scripCode
            //   );
            // } else {
            // response = await scriptDetailsForFOOrder(
            //   localScripData.exchange,
            //   localScripData.exchangeType,
            //   localScripData.scripCode
            // );
            // }
            // For Mock Data
            // if (REACT_APP_ENV == "development")
            //   response = { data: getScripDetailsForFoOrder() };
            response = yield getIndexPCR(nameBreakup.name.split(" ")[0].toLowerCase());
            const companyArray = (_g = (_f = (_e = response === null || response === void 0 ? void 0 : response.data.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.companylist) === null || _g === void 0 ? void 0 : _g.company;
            const lotSize = ((_h = companyArray === null || companyArray === void 0 ? void 0 : companyArray[0]) === null || _h === void 0 ? void 0 : _h.marketlot) || 1;
            //const lotSize = response.data.MktLot;
            if (!scripData.lotSize || scripData.lotSize == 0) {
                lotSize && setLotSize(lotSize);
            }
            else {
                setLotSize(scripData.lotSize);
            }
            if (segmentTypeObj.productType == "CASH") {
                setLotSize(1);
            }
            // setLotSize(lotSize);
            if (response.data.ShortCode) {
                localScripData.shortCodeMessage = response.data.ShortCode;
            }
            else {
                localScripData.shortCodeMessage = undefined;
            }
            setLocalScripData(Object.assign({}, localScripData));
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    });
    // const getPercentageCalculation = (
    //   numerator: number,
    //   denominator: number
    // ): string => {
    //   const difference = Math.abs(numerator - denominator);
    //   return ((difference * 100) / denominator).toFixed(2);
    // };
    const getMarginDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if ((requestJson === null || requestJson === void 0 ? void 0 : requestJson.stockQuantity) > 0) {
                let tempStockQuantity = requestJson.stockQuantity;
                // IF MCX then multiply by 100
                if (scripPriceData.exchange == EXCHANGE_MAPPING.MCX && lotSize > 0) {
                    tempStockQuantity = requestJson.stockQuantity * lotSize;
                }
                const response = yield preOrdMarginCalculation(clientCode, scripPriceData.exchange, scripPriceData.exchangeType, scripPriceData.scripCode, "P", formType == "BUY" ? "B" : "S", requestJson.price == 0 ? "Y" : "N", Number(requestJson.price), tempStockQuantity, productType == "delivery" ? "D" : "I");
                setLoadingMarginDetail(false);
                setMarginDetail(response.data.body);
            }
        }
        catch (err) {
            console.error(err);
        }
    });
    useEffect(() => {
        if (requestJson.stockQuantity > 0) {
            //getMarginDetails();
        }
    }, [
        formType,
        productType,
        requestJson.price,
        requestJson.stockQuantity,
        scripPriceData.exchange,
        scripPriceData.exchangeType,
        scripPriceData.scripCode,
        lotSize,
    ]);
    // useEffect(() => {
    // getBrokergeChargesCallback();
    // }, [requestJson.stockQuantity, lotSize]);
    const sendOrderRequestWrapper = () => {
        // if (scripData.basketDetails) {
        //   onCloneIconClick(scripData);
        // } else {
        if (!execute) {
            setExecute(true);
        }
        const buttonText = getLabelForExecuteButton();
        let eventName = "Order Paced";
        switch (buttonText) {
            case "Add To Basket":
                eventName = "Added to basket";
                break;
            case "Modify Order":
                eventName = "Order Modified";
                break;
            case "Place Order":
                eventName = "Order Placed";
                break;
        }
        // captureCleverTabAnalytics(`Buy/Sell - ${eventName}`, {
        //   ProductType: productType,
        //   TimeType: timeType,
        //   ...buySellData,
        // });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    // const onCloneIconClick = async (cloneStockData) => {
    //   //anks
    //   let ValidTillDate = cloneStockData?.orderData?.ValidTillDate;
    //   if (!isEmpty(ValidTillDate)) {
    //     ValidTillDate = ValidTillDate.replace("/Date(", "")
    //       .replace(")/", "")
    //       .split("+")[0];
    //   }
    //   const validity =
    //     dayType == "vtd" && !isEmpty(ValidTillDate)
    //       ? new Date(Number(ValidTillDate))
    //       : new Date();
    //   validity.setHours(23);
    //   validity.setMinutes(59);
    //   validity.setSeconds(59);
    //   validity.setMilliseconds(999);
    //   const payload = {
    //     // ClientCode:requestJson.clientCode,
    //     Exchange: requestJson.exchange,
    //     ExchangeType: requestJson.exchangeType,
    //     Price: requestJson.price,
    //     OrderType: requestJson.transactionType,
    //     Qty: requestJson.stockQuantity,
    //     ScripCode: requestJson.scripCode,
    //     AtMarket: requestJson.atMarket,
    //     StopLossPrice: requestJson.stopLossTriggerPrice,
    //     IsStopLossOrder: requestJson.isStopLoss,
    //     IOCOrder: requestJson.isIoc,
    //     DelvIntra: productType == "delivery" ? "D" : "I",
    //     IsIntraday: requestJson.isIntraDay,
    //     ValidTillDate: validity.getTime() + "",
    //     AHPlaced: "N",
    //     PublicIP: "0.0.0.0",
    //     DisQty: requestJson.disclosedQuantity,
    //     iOrderValidity: requestJson.disclosedQuantity,
    //     AppSource: "21",
    //     orderFor: scripData.orderFor,
    //     name: scripData.name,
    //   };
    //   try {
    //     const body = {
    //       ...payload,
    //       BasketIDs: [{ BasketID: scripData.basketDetails.BasketId }],
    //     };
    //     const resp = await addToBasket(body);
    //     const addOrderToBasketResData = resp.data.body.AddOrderToBasketResData;
    //     const message = resp.data.body.Message;
    //     if (addOrderToBasketResData == null) {
    //       executeCalback(false, message);
    //     } else {
    //       executeCalback(true, "Order Cloned successfully.");
    //     }
    //   } catch (error) {
    //     console.error(error);
    //     captureAddToBasket(false, "Something went wrong.");
    //     ToastUtils.error("Something went wrong.");
    //   }
    // };
    // onDestroy
    // useEffect(() => {
    //   return () => {
    //   };
    // }, []);
    const getSliceLimitCallback = () => __awaiter(void 0, void 0, void 0, function* () {
        // let response = await getSliceLimit(
        //   localScripData.exchange,
        //   localScripData.exchangeType,
        //   localScripData.scripCode
        // );
        // if (REACT_APP_ENV == "development") {
        let response = { data: getSliceLimitDummyData() };
        // }
        if (response.data.body.Status == 0 && response.data.body.Qtylimit > 0) {
            setSliceLimitData({
                qtyLimit: response.data.body.Qtylimit,
                isSliceEnable: response.data.body.SliceEnable == "Y",
                isConsentReceived: false,
            });
        }
        // response.data.body.Qtylimit;
        // response.data.body.SliceEnable;
    });
    useEffect(() => {
        const getDepthToggle = Object.assign({}, depthToggle);
        setDepthToggle({
            show20: getDepthToggle.show20,
            toggleShowQuotes: getDepthToggle.toggleShowQuotes,
            fullHeighModal: timeType,
        });
    }, [timeType]);
    //modifyUseEffect
    useEffect(() => {
        var _a, _b, _c, _d;
        // console.log(JSON.stringify(scripData));
        const cloneScripData = JSON.parse(JSON.stringify(scripData));
        //setting default values
        if (cloneScripData.allowBktOrder == undefined) {
            // console.log("allowBktOrder this");
            cloneScripData.allowBktOrder = true;
        }
        if (cloneScripData.exchangeType === "C" &&
            !((_a = getLabelForExecuteButton()) === null || _a === void 0 ? void 0 : _a.includes("Modify"))) {
            // nseBseStateSave(
            //   cloneScripData.exchange,
            //   cloneScripData.exchangeType,
            //   cloneScripData.scripCode
            // );
        }
        setLocalScripData(cloneScripData);
        setScripPriceData(Object.assign({}, cloneScripData));
        setFormType(cloneScripData.isBuy ? "BUY" : "SELL");
        setTimeType("regular");
        setProductType("delivery");
        if (cloneScripData.timeType) {
            setTimeType(cloneScripData.timeType);
        }
        if (cloneScripData.netPositionDetail) {
            const DelvIntra = cloneScripData.netPositionDetail.OrderFor;
            if (DelvIntra == "S" || DelvIntra == "C") {
                setTimeType("regular");
                setProductType("intraday");
            }
            else if (DelvIntra == "I") {
                setProductType("intraday");
            }
        }
        else if (cloneScripData.orderData) {
            setDisclosedQuantityCallback(cloneScripData.orderData.DisClosedQty);
            if (!isBasket &&
                !moment(cloneScripData.orderData.OrderValidUpto).isSameOrBefore(moment())) {
                const orderValidUpto = (_b = cloneScripData === null || cloneScripData === void 0 ? void 0 : cloneScripData.orderData) === null || _b === void 0 ? void 0 : _b.OrderValidUpto;
                if (orderValidUpto &&
                    typeof orderValidUpto != "number" &&
                    !(orderValidUpto === null || orderValidUpto === void 0 ? void 0 : orderValidUpto.includes("/Date"))) {
                    const date = new Date(orderValidUpto);
                    setValidityDate((_c = date === null || date === void 0 ? void 0 : date.toISOString()) === null || _c === void 0 ? void 0 : _c.split("T")[0]);
                }
                else if (orderValidUpto) {
                    const date = new Date(orderValidUpto);
                    setValidityDate((_d = date === null || date === void 0 ? void 0 : date.toISOString()) === null || _d === void 0 ? void 0 : _d.split("T")[0]);
                }
            }
            const DelvIntra = cloneScripData.orderData.DelvIntra;
            if (DelvIntra == "I" || DelvIntra == "S" || DelvIntra == "C") {
                setProductType("intraday");
            }
            if (DelvIntra == "S" || DelvIntra == "C") {
                setTimeType("regular");
            }
            else if (cloneScripData.orderData.WithSL == "Y") {
                setTimeType("stoploss");
            }
            if (cloneScripData.orderData.OrderValidity == 0) {
                // onDayTypeChange("day"); not required as default is day
            }
            else if (cloneScripData.orderData.OrderValidity == 1) {
                onDayTypeChange("vtd");
            }
            else if (cloneScripData.orderData.OrderValidity == 2) {
                onDayTypeChange("gtc");
            }
            else if (cloneScripData.orderData.OrderValidity == 3) {
                onDayTypeChange("ioc");
            }
        }
        else if (cloneScripData.vttOrderDetail) {
            setTimeType("vtt");
            setProductType("delivery");
        }
    }, [scripData]);
    useEffect(() => {
        getScripDetails();
        setSliceLimitData(undefined);
        getSliceLimitCallback();
    }, [localScripData.scripCode]);
    //================================Quantity and above close=======================
    const onTimeTypeChange = (type) => {
        setTimeType(type);
        passQtyAndPriceBetweenForms(productType, type);
    };
    const onProductTypeChange = (type) => {
        setProductType(type);
        if (type == "intraday" && timeType == "vtt") {
            onTimeTypeChange("regular");
            passQtyAndPriceBetweenForms(type, "regular");
        }
        else {
            passQtyAndPriceBetweenForms(type, timeType);
        }
    };
    // const updateLocalScripData = (): void => {
    //   localScripData.isBuy = formType == "BUY";
    //   // localScripData.
    // };
    const passQtyAndPriceBetweenForms = (localProductType, localTimeType) => {
        // const cloneScripPriceData = { ...localScripData };
        const cloneScripPriceData = JSON.parse(JSON.stringify(localScripData));
        const price = checkIsEmpty(requestJson.price)
            ? 0
            : Number(requestJson.price);
        if (localTimeType == "vtt") {
            if (cloneScripPriceData.vttOrderDetail) {
                // InitialLimitPrice
                cloneScripPriceData.vttOrderDetail.InitialTriggerPrice = price;
                cloneScripPriceData.vttOrderDetail.Quantity = requestJson.stockQuantity;
            }
            else {
                cloneScripPriceData.vttOrderDetail = {
                    InitialTriggerPrice: isEmpty(requestJson.price)
                        ? 0
                        : Number(requestJson.price),
                    Quantity: requestJson.stockQuantity,
                    // stockQuantity:requestJson.stockQuantity,
                    BuySell: formType,
                    CreatedOn: "",
                    Exch: cloneScripPriceData.exchange,
                    ExchType: cloneScripPriceData.exchangeType,
                    InitialOrderStatus: "",
                    InitialStatus: "",
                    InitialLimitPrice: 0,
                    InitialTriggerTime: "",
                    MatchingCondition: "LT",
                    ProfitLimitPrice: 0,
                    ProfitOrderStatus: "",
                    ProfitStatus: "",
                    ProfitTriggerPrice: "",
                    SLStatus: "",
                    SLTriggerTime: "",
                    ScripCode: cloneScripPriceData.scripCode,
                    StopLossLimitPrice: 0,
                    StopLossTriggerPrice: 0,
                    Symbol: cloneScripPriceData.name,
                    VTTOrderId: "",
                };
            }
        }
        else {
            if (cloneScripPriceData.netPositionDetail) {
                cloneScripPriceData.netPositionDetail["NetQty"] =
                    requestJson.stockQuantity;
            }
            if (cloneScripPriceData.orderData) {
                cloneScripPriceData.orderData.Rate = price;
                cloneScripPriceData.orderData.AtMarket = price == 0 ? "Y" : "N";
                cloneScripPriceData.orderData.Qty = requestJson.stockQuantity;
            }
            else {
                cloneScripPriceData.orderData = {
                    AtMarket: price == 0 ? "Y" : "N",
                    Rate: price,
                    Qty: requestJson.stockQuantity,
                    AHProcess: requestJson.afterMarketHours,
                    AfterHours: requestJson.afterMarketHours,
                    BrokerOrderId: 0,
                    BuySell: formType,
                    DelvIntra: "D",
                    DisClosedQty: disclosedQuantity,
                    Exch: cloneScripPriceData.exchange,
                    ExchOrderID: 0,
                    ExchType: cloneScripPriceData.exchangeType,
                    MarketLot: lotSize,
                    OrderStatus: "",
                    OrderValidUpto: "",
                    OrderValidity: 0,
                    PendingQty: 0,
                    SLTriggerRate: 0,
                    SMOProfitRate: 0,
                    SMOSLLimitRate: 0,
                    SMOSLTriggerRate: 0,
                    SMOTrailingSL: 0,
                    TradedQty: 0,
                    WithSL: "N",
                    OrderID: 0,
                    StopLossPrice: 0,
                };
            }
        }
        setLocalScripData(cloneScripPriceData);
    };
    const onFormTypeChange = (type) => {
        setFormType(type);
    };
    const onDayTypeChange = (type) => {
        setDayType(type);
    };
    const isDayTypeVisibile = (dayTypeLabel) => {
        if (dayTypeLabel == "day") {
            return true;
        }
        else if (dayTypeLabel == "ioc") {
            return true;
        }
        else if (dayTypeLabel == "gtc" &&
            localScripData.exchange == "M" &&
            productType == "delivery") {
            return true;
        }
        else if (dayTypeLabel == "vtd") {
            if (localScripData.exchangeType == "C") {
                return true;
            }
            else if (localScripData.exchange == "M" && productType == "delivery") {
                return true;
            }
        }
        return false;
    };
    const onDateSelected = (type) => {
        setValidityDate(type);
    };
    const setDisclosedQuantityCallback = (disQty) => {
        if (disQty != disclosedQuantity) {
            setDisclosedQuantity(disQty);
        }
    };
    const setDisQtyErrorMessageCallback = () => {
        if (disclosedQuantity == 0) {
            setDisQtyErrorMessage("");
        }
        else if (disclosedQuantity > requestJson.stockQuantity) {
            setDisQtyErrorMessage("Disclosed Quantity cannot be greater than actual quantity");
        }
        else if (disclosedQuantity < requestJson.stockQuantity * 0.1) {
            setDisQtyErrorMessage("Disclosed Quantity needs to be greater than 10% of actual quantity");
        }
        else {
            setDisQtyErrorMessage("");
        }
    };
    useEffect(() => {
        setDisQtyErrorMessageCallback();
    }, [disclosedQuantity, requestJson.stockQuantity]);
    const requestJsonCallback = (returnValue) => {
        setRequestJson(returnValue);
    };
    const executeCalback = (isSuccess, message) => {
        setExecute(false);
        if (message) {
            if (isSuccess) {
                captureBuySellAnalytics(true, `${formType}`, `${localScripData.name}`);
                captureCleverTabAnalytics((scripData === null || scripData === void 0 ? void 0 : scripData.isBuy) ? "Buy_Trade_Successful" : "Sell_Trade_Successful", {
                    Initiation_Screen: scripData.openedFrom,
                    Client_Code: clientCode,
                    Script_Name: scripData.name,
                    Exchange: requestJson.exchange,
                    Order_Type: requestJson.transactionType,
                    Product_Type: productType,
                    Margin_Activated: marginPlus == "Y" ? "Yes" : "No",
                    Validity: nameBreakup.expiry,
                    Qty: requestJson.stockQuantity,
                    CMP: requestJson.price,
                });
                ToastUtils.success(message);
            }
            else {
                captureBuySellAnalytics(false, `${formType}`, `${localScripData.name}`);
                captureCleverTabAnalytics((buySellData === null || buySellData === void 0 ? void 0 : buySellData.isBuy) ? "Buy_Trade_Fail" : "Sell_Trade_Fail", {
                    Initiation_Screen: scripData.openedFrom,
                    Client_Code: clientCode,
                    Script_Name: scripData.name,
                    Exchange: requestJson.exchange,
                    Order_Type: requestJson.transactionType,
                    Product_Type: productType,
                    Margin_Activated: marginPlus == "Y" ? "Yes" : "No",
                    Validity: nameBreakup.expiry,
                    Qty: requestJson.stockQuantity,
                    CMP: requestJson.price,
                });
                ToastUtils.error(message, { autoClose: 5000 });
            }
        }
        if (isSuccess) {
            closeCallback(true);
        }
    };
    const changePriceValues = getChangeAndChangePercentage(scripPriceData.lastTradePrice, scripPriceData.previousClose);
    const updateMarketEnabled = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if ((userMarketEnabled === null || userMarketEnabled === void 0 ? void 0 : userMarketEnabled.AllowNseDeriv) === "N") {
                const response = yield checkLogin();
                const marketStatusYesNo = {};
                const Obj = response.data.body;
                Object.entries(Obj).map(([key, value]) => {
                    if (key.substring(0, 5) == "Allow")
                        marketStatusYesNo[key] = value;
                });
                setUserMarketEnabled(marketStatusYesNo);
                setDataInSession(SESSION_KEYS.USERMARKETENABLED, marketStatusYesNo, true);
            }
        }
        catch (err) {
            console.error(err);
        }
    });
    const getForm = () => {
        if (timeType == "vtt") {
            return (_jsx(VttBuyForm, { timeType: timeType, productType: productType, formType: formType, lotSize: lotSize, scripData: localScripData, scripPriceData: scripPriceData, returnValue: requestJsonCallback, execute: execute, executeCallback: executeCalback, isLoading: isLoading, fetchSetting: fetchSetting, 
                // sliceLimitData={sliceLimitData}
                isFormValid: (isFormValidValue) => {
                    setFormValid(isFormValidValue);
                }, isBuyForm: true }));
        }
        else if (timeType == "regular" && productType == "intraday") {
            return (_jsx(IntraDayRegularBuyForm, { formType: formType, lotSize: lotSize, scripData: localScripData, scripPriceData: scripPriceData, returnValue: requestJsonCallback, execute: execute, executeCallback: executeCalback, afterMarketHours: afterMarketHours, validityDate: validityDate, dayType: dayType, sliceLimitData: sliceLimitData, isLoading: isLoading, disclosedQuantity: disclosedQuantity, isFormValid: (isFormValidValue) => {
                    setFormValid(isFormValidValue);
                }, toggleSliceConsent: toggleMaximumOrderModal, fetchSetting: fetchSetting, isBuyForm: true }));
        }
        else {
            return (_jsx(RegularStopLossBuyForm, { formType: formType, lotSize: lotSize, scripData: localScripData, scripPriceData: scripPriceData, returnValue: requestJsonCallback, execute: execute, executeCallback: executeCalback, afterMarketHours: afterMarketHours, validityDate: validityDate, productType: productType, timeType: timeType, dayType: dayType, sliceLimitData: sliceLimitData, disclosedQuantity: disclosedQuantity, isLoading: isLoading, isFormValid: (isFormValidValue) => {
                    setFormValid(isFormValidValue);
                }, toggleSliceConsent: toggleMaximumOrderModal, fetchSetting: fetchSetting, isBuyForm: true }));
        }
    };
    const productTypeVisibility = (productTypeLabel) => {
        var _a, _b;
        if (isBasket) {
            // return true;
        }
        else if (localScripData.orderFor == "M") {
            if (timeType == "vtt") {
                if (productTypeLabel == "delivery") {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (productTypeLabel == "intraday") {
                if (((_a = localScripData.orderData) === null || _a === void 0 ? void 0 : _a.DelvIntra) != "D") {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (productTypeLabel == "delivery") {
                if (((_b = localScripData.orderData) === null || _b === void 0 ? void 0 : _b.DelvIntra) == "D") {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else {
        }
        return true;
    };
    const timeTypeVisibility = (timeTypeLabel) => {
        var _a, _b, _c, _d;
        if (localScripData.orderFor == "M" && !isBasket) {
            if (timeTypeLabel == "vtt") {
                if (localScripData.vttOrderDetail) {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (timeTypeLabel == "regular") {
                if (((_a = localScripData.orderData) === null || _a === void 0 ? void 0 : _a.WithSL) == "N" ||
                    ((_b = localScripData.orderData) === null || _b === void 0 ? void 0 : _b.WithSL) == "Y") {
                    return true;
                }
                else {
                    return false;
                }
            }
            else if (timeTypeLabel == "stoploss") {
                if (localScripData.orderData) {
                    const DelvIntra = localScripData.orderData.DelvIntra;
                    if (DelvIntra == "S" || DelvIntra == "C") {
                        return false;
                    }
                    else {
                        if (((_c = localScripData.orderData) === null || _c === void 0 ? void 0 : _c.WithSL) == "N" ||
                            ((_d = localScripData.orderData) === null || _d === void 0 ? void 0 : _d.WithSL) == "Y") {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
                else if (localScripData.vttOrderDetail) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                //New time type handling will be here;
                return false;
            }
        }
        else if (productType == "intraday") {
            if (timeTypeLabel == "vtt") {
                return false;
            }
        }
        else if (timeTypeLabel == "vtt") {
            if (isBasket) {
                return false;
            }
            else if (localScripData.exchange == "M") {
                return false;
            }
            else if (localScripData.exchangeType == "U") {
                return false;
            }
        }
        return true;
    };
    //unmount effect
    useEffect(() => {
        return () => {
            //unmount call here
            // tokensData.current = undefined;
            buyFormRef.current = null;
            executeRef.current = undefined;
            unsubscribeDataBySubscriber(componentName);
        };
    }, []);
    const nameBreakup = splitAndGetDetailsFromLongName(localScripData.name);
    const [exchange, setExchange] = useState();
    const [exhangeColor, setExhangeColor] = useState();
    useEffect(() => {
        const exchangeName = getDisplayTextFromExchange(localScripData.exchange, localScripData.exchangeType);
        const exchangeColName = getExhangeColor(exchangeName);
        setExchange(exchangeName);
        setExhangeColor(exchangeColName);
    }, [localScripData]);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        //console.log(segmentTypeObj,"productType");
        const myPreferences = getPreferences();
        const productTypeSetting = ORDER_SETTINGS.find((element) => element.productType == segmentTypeObj.productType &&
            element.segmentType == segmentTypeObj.segmentType);
        if (productTypeSetting) {
            // console.log(
            //   myPreferences.orderSettings[productTypeSetting.key],
            //   "productType"
            // );
            //const fetchSetting = myPreferences.orderSettings[productTypeSetting.key];
            if (!scripData.orderData &&
                !getLabelForExecuteButton().includes("Modify") &&
                !((_a = scripData.openedFrom) === null || _a === void 0 ? void 0 : _a.includes("Ideas")) &&
                !((_b = scripData.openedFrom) === null || _b === void 0 ? void 0 : _b.includes("Quick Option trade")) &&
                !((_c = scripData.openedFrom) === null || _c === void 0 ? void 0 : _c.includes("re-order")) &&
                !((_d = scripData.openedFrom) === null || _d === void 0 ? void 0 : _d.includes("square-off")) &&
                !((_e = scripData.openedFrom) === null || _e === void 0 ? void 0 : _e.includes("Footer Order"))) {
                setfetchSetting(myPreferences.orderSettings[productTypeSetting.key]);
                if (scripData.timeType == "vtt") {
                    setProductType("delivery");
                }
                else {
                    setProductType(myPreferences.orderSettings[productTypeSetting.key].productType);
                }
            }
        }
        //setProductType(productType)
    }, [scripData]);
    useEffect(() => {
        if (toggleHideAndShow !== picker.modalToggleHideShow) {
            setToggleHNS(picker.modalToggleHideShow);
        }
    }, [picker.modalToggleHideShow]);
    const pinModal = useCallback(() => {
        const myPreferences = getPreferences();
        //setDataInSession(myPreferences.buyform.depthPin,!pinnedStatus)
        setPinnedStatus(!pinnedStatus);
        myPreferences.buyform.depthPin = !pinnedStatus;
        setPreferences(myPreferences);
    }, []);
    const exhangeTypeColor = getExhangeTypeColor(nameBreakup.scripType);
    //test comment
    const getLabelForExecuteButton = () => {
        let labelValue = "Place Order";
        if (localScripData.isBasket) {
            if (localScripData.orderFor == "P") {
                // if (scripData.basketDetails) {
                //   labelValue = "Clone";
                // } else {
                labelValue = "Add To Basket";
                // }
            }
            else {
                labelValue = "Modify Order";
            }
        }
        else if (timeType == "vtt") {
            if (localScripData.orderFor == "P") {
                labelValue = "Place Order";
            }
            else {
                labelValue = "Modify Order";
            }
        }
        else if (localScripData.orderFor == "P") {
        }
        else {
            labelValue = "Modify Order";
        }
        return labelValue;
    };
    const segmentTypeObj = getSegmentAndProductType(localScripData.name, localScripData.exchange, localScripData.exchangeType);
    const nseBseStateSave = (exch, exchType, code) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // const fetchScripResponse = await { data: getCashFilter() };
            const fetchScripResponse = yield cashFilter(exch, exchType, code);
            if (fetchScripResponse.data.lstCashScrip.length > 0 &&
                fetchScripResponse.data.Status === 0) {
                if (fetchScripResponse.data.lstCashScrip[0].Exchange === "B") {
                    setNseCode({
                        exchange: exch,
                        exchangeType: exchType,
                        scripCode: code,
                    });
                    setBseCode({
                        exchange: fetchScripResponse.data.lstCashScrip[0].Exchange,
                        exchangeType: fetchScripResponse.data.lstCashScrip[0].ExchangeType,
                        scripCode: fetchScripResponse.data.lstCashScrip[0].ScripCode,
                    });
                }
                else if (fetchScripResponse.data.lstCashScrip[0].Exchange === "N") {
                    setNseCode({
                        exchange: fetchScripResponse.data.lstCashScrip[0].Exchange,
                        exchangeType: fetchScripResponse.data.lstCashScrip[0].ExchangeType,
                        scripCode: fetchScripResponse.data.lstCashScrip[0].ScripCode,
                    });
                    setBseCode({
                        exchange: exch,
                        exchangeType: exchType,
                        scripCode: code,
                    });
                }
            }
            else {
                setNseCode({ exchange: "", exchangeType: "", scripCode: 0 });
                setBseCode({ exchange: "", exchangeType: "", scripCode: 0 });
            }
        }
        catch (_j) {
            setNseCode({ exchange: "", exchangeType: "", scripCode: 0 });
            setBseCode({ exchange: "", exchangeType: "", scripCode: 0 });
        }
    });
    const nseBseClick = (value) => {
        setNseBseShimmer(true);
        if (nseCode.scripCode !== 0 && bseCode.scripCode !== 0) {
            const data = Object.assign({}, value);
            if (data.exchange === "N") {
                data.exchange = bseCode.exchange;
                data.exchangeType = bseCode.exchangeType;
                data.scripCode = bseCode.scripCode;
            }
            else if (data.exchange === "B") {
                data.exchange = nseCode.exchange;
                data.exchangeType = nseCode.exchangeType;
                data.scripCode = nseCode.scripCode;
            }
            setExhangeColor(getExhangeColor(data.exchange === "N" ? "BSE" : "NSE"));
            setExchange(getDisplayTextFromExchange(data.exchange === "N" ? "B" : "N", data.exchangeType));
            setLocalScripData(data);
            setScripPriceData(Object.assign({}, data));
        }
    };
    useEffect(() => {
        setNseBseShimmer(false);
    }, [localScripData]);
    const checkAsmGsmPoupStatus = (data) => {
        let showPopup = false;
        if ((data === null || data === void 0 ? void 0 : data.shortCodeMessage) !== undefined) {
            // if (
            showPopup = true;
            //   data.netPositionDetail !== undefined &&
            //   ((data.netPositionDetail.BuySell === "BUY" && data.isBuy === true) ||
            //     (data.netPositionDetail.BuySell === "SELL" && data.isBuy === false))
            // ) {
            //   showPopup = true;
            // } else if (data.vttOrderDetail !== undefined) {
            //   showPopup = true;
            // } else if (data.orderData !== undefined && data.orderFor === "P") {
            //   showPopup = true;
            // } else if (data.isBasket === true) {
            //   showPopup = true;
            // }
            // if (
            //   data.netPositionDetail === undefined &&
            //   data.orderData === undefined &&
            //   data.vttOrderDetail === undefined
            // ) {
            //   showPopup = true;
            // }
        }
        return showPopup;
    };
    // NOT IN USE AFTER V6/ScripDetailsFoFOOrder
    // const checkSurveillanceIndicator = (code): boolean => {
    //   let status = false;
    //   if (
    //     code == 80 ||
    //     code == 81 ||
    //     code == 82 ||
    //     code == 83 ||
    //     code == 84 ||
    //     code == 9999
    //   ) {
    //     status = true;
    //   }
    //   return status;
    // };
    const isBuyButtonVisible = useCallback(() => {
        if (userMarketEnabled &&
            (userMarketEnabled === null || userMarketEnabled === void 0 ? void 0 : userMarketEnabled.AllowNseDeriv) === "N" &&
            localScripData.exchangeType != "C") {
            return false;
        }
        return true;
    }, [userMarketEnabled]);
    // const commonLtpRendererCallback = useCallback((ltp, prevClose) => {
    //   return (
    //     <span>
    //       <div className={`${styles.value} d-flex`}>{ltp}</div>
    //     </span>
    //   );
    // }, []);
    const commonLtpRenderCallBack = useCallback((scripCode, ltp, prevClose, changePercentObj) => {
        // if (isEmpty(ltp)) {
        //   return <></>;
        // }
        //  console.log(changePercentObj, "changePercentObj", ltp, "ltp");
        // indiceMapRef.current[scripCode] = { ltp, prevClose };
        return ltp === "" ? (_jsx(Shimmer, {})) : (_jsxs(_Fragment, { children: [_jsx("span", { children: _jsx("div", Object.assign({ className: `${styles.value} d-flex` }, { children: ltp })) }), _jsx("span", Object.assign({ className: `${styles.ltpChangeValue} ${changePercentObj.isNegative ? "negativeText" : "positiveText"} small mx-1` }, { children: changePercentObj.differenceValue }))] }));
    }, []);
    const setPicker = (data) => {
        setPickerData(data);
    };
    const setSepthSnapToggleContext = (data) => {
        setDepthToggle(data);
    };
    // useEffect(() => {
    //   if (isGuestLoginModalOpen) {
    //     //setShiftBuyForm(true);
    //     document.body.style.overflowY = "scroll";
    //     document.body.style.paddingRight = "0px";
    //   } else {
    //     //setShiftBuyForm(false);
    //     document.body.style.overflowY = "auto";
    //   }
    // }, [isGuestLoginModalOpen]);
    return (_jsx(PricePickerContext.Provider, Object.assign({ value: { picker, setPicker } }, { children: _jsx(DepthSnapToggleContext.Provider, Object.assign({ value: {
                depthToggle: depthToggle,
                setDepthSnapToggleContext: setSepthSnapToggleContext,
            } }, { children: _jsxs(OutsideClickHandler, Object.assign({ onOutsideClick: () => setFocusOnPopUp(false) }, { children: [_jsx(Draggable, Object.assign({ handle: "#handle" }, { children: _jsxs("div", Object.assign({ id: "buysell", className: `${styles.buyformSection} ${toggleHideAndShow ? styles.depthWrapper : ""}`, style: {
                                borderColor: formType == "BUY" ? "#00b29e" : "#e5455d",
                            }, onClick: () => setFocusOnPopUp(true) }, { children: [_jsxs("div", Object.assign({ className: styles.buyformSectionInner }, { children: [_jsxs("div", Object.assign({ className: styles.buyformHeader, id: "handle", tabIndex: -1 }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-center mb-2" }, { children: [_jsxs("h6", Object.assign({ className: `${styles.sectionTitle} mb-0` }, { children: [_jsx("span", Object.assign({ className: `${styles.scripName}` }, { children: nameBreakup.name })), _jsx("span", Object.assign({ className: "darkGreyText" }, { children: getDefaultDateFormat(nameBreakup.expiry) })), _jsx("span", Object.assign({ className: `${exhangeTypeColor} mx-1` }, { children: nameBreakup.scripType })), _jsx("span", Object.assign({ className: "darkGreyText" }, { children: Number.isInteger(nameBreakup.strikeRate)
                                                                        ? intComma(nameBreakup.strikeRate, 0)
                                                                        : !nameBreakup.strikeRate
                                                                            ? ""
                                                                            : nameBreakup.strikeRate }))] })), _jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsxs("div", Object.assign({ className: `${styles.buySellTab}` }, { children: [(localScripData.orderFor != "M" || isBasket) && (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: `${formType == "BUY" ? styles.activeBuy : ""} me-1`, onClick: () => onFormTypeChange("BUY") }, { children: "Buy" })), _jsx("span", Object.assign({ className: `${formType == "SELL" ? styles.activeSell : ""}`, onClick: () => onFormTypeChange("SELL") }, { children: "Sell" }))] })), localScripData.orderFor == "M" && !isBasket && (_jsx("span", Object.assign({ className: `${formType === "SELL"
                                                                                ? styles.activeSell
                                                                                : styles.activeBuy}` }, { children: formType == "BUY" ? "Buy" : "Sell" })))] })), _jsx("div", Object.assign({ className: `${styles.marketDepthIconWrapper}`, onClick: () => {
                                                                        const getPicker = Object.assign({}, picker);
                                                                        setPicker({
                                                                            price: getPicker.price,
                                                                            type: getPicker.type,
                                                                            modalToggleHideShow: !getPicker.modalToggleHideShow,
                                                                        });
                                                                    } }, { children: _jsxs("svg", Object.assign({ className: `${styles.marketDepthIcon} ${picker.modalToggleHideShow ? styles.active : ""} `, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M4.11151 5.83594H8.84762", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M4.11151 9.28125H8.84762", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M4.11151 12.7227H8.84762", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M4.11151 16.168H8.84762", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M13.1532 5.83594H17.8893", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M13.1532 9.28125H17.8893", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M13.1532 12.7227H17.8893", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M13.1532 16.168H17.8893", stroke: "#1570EF", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })) })), isOrderSetting && (_jsx("span", { className: "settingsIcon me-2 mt-n2px", onClick: toggleSettingModal })), _jsx("span", { className: "closeIcon1", onClick: () => closeCallback(false), ref: buyFormRef, id: "closeButton", title: "Close" })] }))] })), _jsx("div", Object.assign({ className: "d-flex align-items-center justify-content-between" }, { children: _jsx("div", Object.assign({ className: "d-flex align-items-center" }, { children: _jsx("div", Object.assign({ className: "nseBseWrapper" }, { children: _jsxs("div", Object.assign({ className: "nseNfoWidth" }, { children: [exchange === "BSE" && bseCode.scripCode !== 0 && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "nseBseRadio me-2" }, { children: [_jsx("input", { type: "radio", name: "exchangeTypeNse", value: "nse", checked: "N" === localScripData.exchange, onClick: () => {
                                                                                            localScripData.exchange !== "N"
                                                                                                ? nseBseClick(localScripData)
                                                                                                : () => { };
                                                                                        } }), _jsx("label", { children: "NSE" })] })), _jsx(CommonLtpRenderer, { scripCode: nseCode.scripCode, exch: nseCode.exchange, exchType: nseCode.exchangeType, renderElement: (ltp, prevClose, changePercentObj) => {
                                                                                    return commonLtpRenderCallBack(nseCode.scripCode, ltp, prevClose, changePercentObj);
                                                                                }, componentName: "BuyForm" + localScripData.scripCode })] })), _jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "nseBseRadio me-2" }, { children: [_jsx("input", { type: "radio", name: "exchangeType", value: exchange === null || exchange === void 0 ? void 0 : exchange.toLowerCase(), checked: EXCHANGE_MAPPING[exchange ? exchange : "NSE"] === localScripData.exchange, onClick: () => {
                                                                                            EXCHANGE_MAPPING[exchange ? exchange : "NSE"] !== localScripData.exchange
                                                                                                ? nseBseClick(localScripData)
                                                                                                : undefined;
                                                                                        } }), _jsx("label", { children: exchange })] })), _jsx(CommonLtpRenderer, { scripCode: localScripData.scripCode, exch: localScripData.exchange, exchType: localScripData.exchangeType, renderElement: (ltp, prevClose, changePercentObj) => {
                                                                                    return commonLtpRenderCallBack(localScripData.scripCode, ltp, prevClose, changePercentObj);
                                                                                }, componentName: "BuyForm" + localScripData.scripCode })] }), exchange === "NSE" && bseCode.scripCode !== 0 && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "nseBseRadio me-2" }, { children: [_jsx("input", { type: "radio", name: "exchangeTypeBSE", value: "bse", checked: "B" === localScripData.exchange, onClick: () => {
                                                                                            localScripData.exchange !== "B"
                                                                                                ? nseBseClick(localScripData)
                                                                                                : () => { };
                                                                                        } }), _jsx("label", { children: "BSE" })] })), _jsx(CommonLtpRenderer, { scripCode: bseCode.scripCode, exch: bseCode.exchange, exchType: bseCode.exchangeType, renderElement: (ltp, prevClose, changePercentObj) => {
                                                                                    return commonLtpRenderCallBack(bseCode.scripCode, ltp, prevClose, changePercentObj);
                                                                                }, componentName: "BuyForm" + localScripData.scripCode })] }))] })) })) })) })), _jsxs("div", Object.assign({ className: `${styles.expiryWrapper} mb-0 d-none` }, { children: [_jsx("span", Object.assign({ className: "darkGreyText" }, { children: getDefaultDateFormat(nameBreakup.expiry) })), _jsx("span", Object.assign({ className: `${exhangeTypeColor} ms-1` }, { children: nameBreakup.scripType })), _jsx("span", Object.assign({ className: "darkGreyText" }, { children: Number.isInteger(nameBreakup.strikeRate)
                                                                ? intComma(nameBreakup.strikeRate, 0)
                                                                : !nameBreakup.strikeRate
                                                                    ? ""
                                                                    : nameBreakup.strikeRate }))] }))] })), _jsxs("div", Object.assign({ className: styles.buyformBody }, { children: [_jsxs("div", Object.assign({ tabIndex: -1, className: `${styles.deliveryTypeWrapper} d-flex justify-content-between align-items-center mb-2}` }, { children: [_jsxs("div", Object.assign({ className: `${styles.deliveryType} d-flex` }, { children: [productTypeVisibility("delivery") && (_jsx("span", Object.assign({ className: productType == "delivery" ? styles.active : "", onClick: () => onProductTypeChange("delivery") }, { children: "Delivery" }))), productTypeVisibility("intraday") && (_jsx("span", Object.assign({ className: productType == "intraday" ? styles.active : "", onClick: () => onProductTypeChange("intraday") }, { children: "Intraday" })))] })), _jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-center" }, { children: [_jsxs("ul", Object.assign({ className: `${styles.activityType} d-flex mb-0 p-0` }, { children: [timeTypeVisibility("regular") && (_jsx("li", Object.assign({ className: `${timeType == "regular" ? styles.active : ""}`, onClick: () => onTimeTypeChange("regular") }, { children: "Regular" }))), timeTypeVisibility("stoploss") && (_jsx("li", Object.assign({ className: `${timeType == "stoploss" ? styles.active : ""}`, onClick: () => onTimeTypeChange("stoploss") }, { children: "StopLoss" }))), timeTypeVisibility("vtt") && (_jsx("li", Object.assign({ className: ` ${timeType == "vtt" ? styles.active : ""}`, onClick: () => onTimeTypeChange("vtt") }, { children: "VTT" })))] })), _jsx("a", Object.assign({ className: "d-flex align-items-center ms-2", href: "https://forum.5paisa.com/portal/en/kb/articles/types-of-stock-trading-order-and-its-validity", target: "blank", tabIndex: -1 }, { children: _jsx("span", { className: "infoSquareIcon1", title: "Info Icon" }) }))] }))] })), _jsxs("div", Object.assign({ className: `${styles.buyformBodyScroll} 
                    ${depthToggle.fullHeighModal == "regular"
                                                        ? styles.regularForm
                                                        : depthToggle.fullHeighModal == "stoploss"
                                                            ? styles.SLForm
                                                            : depthToggle.fullHeighModal == "vtt"
                                                                ? styles.VTTForm
                                                                : ""}` }, { children: [getForm(), timeType != "vtt" && !isBasket && (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "advanceToggleWrapper d-flex justify-content-end mt-3" }, { children: _jsxs("div", Object.assign({ onClick: toggleAdvanceDD, className: `${styles.advanceToggle} d-flex align-items-center flex-grow-0 pointer regularWeight` }, { children: ["Advanced", _jsx("span", { className: `${advanceToggle && "dropdownIconBlueRotate"} dropdownIconBlue ms-1` })] })) })), advanceToggle && (_jsxs("div", Object.assign({ className: `${styles.advancePanel}` }, { children: [_jsx("div", Object.assign({ className: `${styles.stepInputDiscloseQnty}` }, { children: _jsx(StepNumberInput, { isFocus: true, inputLabel: "Disclosed Quantity", defaultValue: disclosedQuantity, placeholder: false, disabled: ((_d = (_c = scripData.bulkModifyArray) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0 > 1)
                                                                                    ? true
                                                                                    : false, stepInput: localScripData.exchange == "M" ? 1 : lotSize, errorMessage: isEmpty(disQtyErrorMessage)
                                                                                    ? "Invalid Quantity"
                                                                                    : disQtyErrorMessage, allowZero: true, showError: !isEmpty(disQtyErrorMessage), returnValue: (data) => {
                                                                                    setDisclosedQuantityCallback(data);
                                                                                }, isBuyForm: true }) })), _jsxs("div", Object.assign({ className: `${styles.dayIocVtdWrapper}` }, { children: [_jsx("label", Object.assign({ htmlFor: "" }, { children: "\u00A0" })), _jsxs("div", Object.assign({ className: `${styles.dayIocVtd} ${styles.deliveryType}` }, { children: [isDayTypeVisibile("day") && (_jsx("span", Object.assign({ className: dayType == "day" ? styles.active : "", onClick: () => onDayTypeChange("day") }, { children: "Day" }))), isDayTypeVisibile("ioc") && (_jsx("span", Object.assign({ className: dayType == "ioc" ? styles.active : "", onClick: () => onDayTypeChange("ioc") }, { children: "IOC" }))), isDayTypeVisibile("gtc") && (_jsx("span", Object.assign({ className: dayType == "gtc" ? styles.active : "", onClick: () => onDayTypeChange("gtc") }, { children: "GTC" }))), isDayTypeVisibile("vtd") && (_jsx("span", Object.assign({ className: dayType == "vtd" ? styles.active : "", onClick: () => onDayTypeChange("vtd") }, { children: localScripData.exchange == "M"
                                                                                                ? "GTD"
                                                                                                : "VTD" })))] })), dayType == "vtd" && (_jsx("div", { className: ` ${styles.dateSelected} d-flex align-items-center mt-3` }))] }))] })))] }))] })), afterMarketHours == "Y" && !isBasket && (_jsxs("p", Object.assign({ className: `${styles.marketNote}` }, { children: [_jsx("span", { children: "Markets closed! " }), "Place now as an after market order (AMO)"] })))] })), _jsx("div", Object.assign({ className: `${styles.buyformFooter}` }, { children: _jsxs("div", Object.assign({ className: "d-flex align-items-center justify-content-between" }, { children: [_jsxs("div", Object.assign({ className: `${styles.marginWrapper}` }, { children: [_jsxs("span", Object.assign({ className: `${styles.marginPlusActivateWrapper} pointer tooltipParent` }, { children: [_jsx("p", Object.assign({ className: "tooltipBox tooltipBoxTop medium" }, { children: _jsx(MarginPlus, { openFrom: "buyForm" }) })), _jsxs("svg", Object.assign({ className: `${styles.marginPlusActivateIcon}`, width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("rect", { y: "0.5", width: "24", height: "24", rx: "12", fill: "#1570EF" }), _jsx("path", { d: "M8.78486 14.8892H9.79735L11.6847 11.1243V16H12.8447V9.119H11.4979L9.33534 13.5327L7.23172 9.119H5.74739V16H6.8975V11.1243L8.78486 14.8892ZM18.8345 12.9625V12.0975H16.8685V10.1315H16.0035V12.0975H14.0375V12.9625H16.0035V14.9384H16.8685V12.9625H18.8345Z", fill: "white" })] }))] })), _jsxs("div", Object.assign({ className: `${styles.marginText}` }, { children: [_jsx("p", { children: "Margin Available" }), _jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsxs("span", { children: ["\u20B9\u00A0", convertNumberToShortText(marginDetail.AvailableMargin)] }), formType == "BUY" ? (_jsxs("svg", Object.assign({ className: "plusIconGreen", width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M7 2.91797V11.0846", stroke: "#00B29E", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M2.91663 7H11.0833", stroke: "#00B29E", strokeLinecap: "round", strokeLinejoin: "round" })] }))) : (_jsxs("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "M7 2.91797V11.0846", stroke: "#ED7D8E", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M2.91663 7H11.0833", stroke: "#ED7D8E", strokeLinecap: "round", strokeLinejoin: "round" })] })))] }))] })), _jsxs("div", Object.assign({ className: `${styles.marginText}` }, { children: [_jsx("p", { children: "Required Margin" }), _jsxs("div", Object.assign({ className: "d-flex align-items-center" }, { children: [_jsxs("span", { children: ["\u20B9\u00A0", convertNumberToShortText(marginDetail.Margin)] }), _jsx("span", Object.assign({ title: "Refresh Icon", onClick: () => {
                                                                                    setLoadingMarginDetail(true);
                                                                                    //getMarginDetails();
                                                                                }, className: `${loadingMarginDetail ? "animate" : ""} ms-1 d-flex pointer` }, { children: formType == "BUY" ? (_jsxs("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsxs("g", Object.assign({ clipPath: "url(#clip0_3092_142166)" }, { children: [_jsx("path", { d: "M11.6667 6.41837C11.524 5.39183 11.0478 4.44067 10.3114 3.71141C9.57499 2.98214 8.61923 2.51524 7.59135 2.38261C6.56347 2.24998 5.52049 2.45898 4.62307 2.97743C3.72566 3.49587 3.0236 4.295 2.62504 5.2517M2.33337 2.91837V5.2517H4.66671", stroke: "#00B29E", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M2.33337 7.58203C2.47603 8.60857 2.95225 9.55973 3.68867 10.289C4.42509 11.0183 5.38085 11.4852 6.40873 11.6178C7.43662 11.7504 8.47959 11.5414 9.37701 11.023C10.2744 10.5045 10.9765 9.7054 11.375 8.7487M11.6667 11.082V8.7487H9.33337", stroke: "#00B29E", strokeLinecap: "round", strokeLinejoin: "round" })] })), _jsx("defs", { children: _jsx("clipPath", Object.assign({ id: "clip0_3092_142166" }, { children: _jsx("rect", { width: "14", height: "14", fill: "white" }) })) })] }))) : (_jsxs("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsxs("g", Object.assign({ clipPath: "url(#clip0_3092_142166)" }, { children: [_jsx("path", { d: "M11.6667 6.41837C11.524 5.39183 11.0478 4.44067 10.3114 3.71141C9.57499 2.98214 8.61923 2.51524 7.59135 2.38261C6.56347 2.24998 5.52049 2.45898 4.62307 2.97743C3.72566 3.49587 3.0236 4.295 2.62504 5.2517M2.33337 2.91837V5.2517H4.66671", stroke: "#ED7D8E", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M2.33337 7.58203C2.47603 8.60857 2.95225 9.55973 3.68867 10.289C4.42509 11.0183 5.38085 11.4852 6.40873 11.6178C7.43662 11.7504 8.47959 11.5414 9.37701 11.023C10.2744 10.5045 10.9765 9.7054 11.375 8.7487M11.6667 11.082V8.7487H9.33337", stroke: "#ED7D8E", strokeLinecap: "round", strokeLinejoin: "round" })] })), _jsx("defs", { children: _jsx("clipPath", Object.assign({ id: "clip0_3092_142166" }, { children: _jsx("rect", { width: "14", height: "14", fill: "white" }) })) })] }))) }))] }))] })), _jsx("div", Object.assign({ className: `${styles.marginText}` }, { children: segmentTypeObj.segmentType != COMMODITY_SEGMENT && (_jsx(ChargesModal
                                                                //toggleChargesModal={toggleChargesModal}
                                                                , { 
                                                                    //toggleChargesModal={toggleChargesModal}
                                                                    mode: productType, quantity: segmentTypeObj.segmentType == EQUITY_SEGMENT
                                                                        ? requestJson.stockQuantity / lotSize
                                                                        : requestJson.stockQuantity, buyPrice: formType == "BUY"
                                                                        ? requestJson.atMarket
                                                                            ? scripPriceData.lastTradePrice
                                                                            : Number(requestJson.price)
                                                                        : 0, sellPrice: formType == "SELL"
                                                                        ? requestJson.atMarket
                                                                            ? scripPriceData.lastTradePrice
                                                                            : Number(requestJson.price)
                                                                        : 0, scripCode: localScripData.scripCode, name: localScripData.name, exch: localScripData.exchange, exchType: localScripData.exchangeType, stockQuantity: requestJson.stockQuantity, lotSize: 1, formType: formType, isLoadingBuyForm: false })) }))] })), _jsx("button", Object.assign({ className: `${formType == "BUY"
                                                            ? styles.executeCtaBuy
                                                            : styles.executeCtaSell} btnType3 medium`, ref: executeRef, 
                                                        // onClick={
                                                        //   !checkAsmGsmPoupStatus(localScripData)
                                                        //     ? sendOrderRequestWrapper
                                                        //     : toggleAsmGsmModal
                                                        // }
                                                        onClick: () => dispatch(openGuestLoginModal()) }, { children: getLabelForExecuteButton() }), "button")] })) }))] })), toggleHideAndShow && (_jsx(MarketDepth, { toggleHideAndShow: toggleHideAndShow, scripData: localScripData, closeModalCallBack: () => {
                                        //console.log("JII");
                                        //setToggleHideAndShow(false)
                                        //setToggleHNS(!toggleHideAndShow);
                                        closeDepthModalCallback();
                                    }, pinnedStatus: pinnedStatus, pinnedCallBack: () => {
                                        pinModal();
                                    } }))] })) })), _jsx(Modal, Object.assign({ isOpen: maximumOrderModal, onRequestClose: toggleMaximumOrderModal, className: `${styles.myCommonModal} ${styles.maximumOrderModal}`, overlayClassName: `${styles.myCommonOverlay} ${styles.maximumOrderOverlay}` }, { children: localScripData && (_jsx(OrderSlicingModal, { scripData: Object.assign(Object.assign({}, localScripData), { quantity: requestJson === null || requestJson === void 0 ? void 0 : requestJson.stockQuantity }), productType: productType, sliceLimitData: sliceLimitData, closeModal: toggleMaximumOrderModal, isConsentReceived: (isConsentValue) => {
                                if (sliceLimitData && isConsentValue) {
                                    const newData = Object.assign({}, sliceLimitData);
                                    newData.isConsentReceived = isConsentValue;
                                    setSliceLimitData(newData);
                                    toggleMaximumOrderModal();
                                    sendOrderRequestWrapper();
                                }
                            } })) })), asmGsmModal && (_jsx(Modal, Object.assign({ isOpen: asmGsmModal, onRequestClose: toggleAsmGsmModal, className: `${styles.myCommonModal} ${styles.asmGsmModalWrapper} asmGsmModalWrapper`, overlayClassName: `${styles.myCommonOverlay} ${styles.asmGsmModalOverlay}` }, { children: checkAsmGsmPoupStatus(localScripData) && (_jsxs("div", Object.assign({ className: `${styles.asmGsmModalInner}` }, { children: [localScripData.shortCodeMessage && (_jsxs("p", { children: ["Caution: ", localScripData.shortCodeMessage] })), _jsx("div", Object.assign({ className: `${styles.knowMoreCss}` }, { children: _jsx("a", Object.assign({ href: "https://forum.5paisa.com/portal/en/kb/5paisa/trading/surveillance-measure", target: "blank" }, { children: "Know more" })) })), _jsxs("div", Object.assign({ className: "buttonWrapper buttonWrapperLarge mt-4" }, { children: [_jsx("button", Object.assign({ className: "btnType2 me-2", onClick: toggleAsmGsmModal }, { children: "No" })), _jsx("button", Object.assign({ className: "btnType1", type: "button", autoFocus: true, onClick: () => {
                                                sendOrderRequestWrapper();
                                                toggleAsmGsmModal();
                                            }, onKeyDown: (e) => {
                                                if (e.key === "Enter") {
                                                    sendOrderRequestWrapper();
                                                    toggleAsmGsmModal();
                                                }
                                            } }, { children: "Yes" }))] }))] }))) }))), settingModal && (
                    // <div className={`${styles.settingModalWrapper}`}>
                    _jsx(SettingModal, { toggleSettingModal: toggleSettingModal, toggleNoteModal: toggleNoteModal })
                    // </div>
                    ), noteModal && (_jsx(Modal, Object.assign({ isOpen: noteModal, onRequestClose: toggleNoteModal, className: `${styles.myCommonModal} ${styles.noteModalWrapper}`, overlayClassName: `${styles.myCommonOverlay} ${styles.noteModalOverlay}` }, { children: _jsx(NoteModal, { toggleNoteModal: toggleNoteModal }) })))] })) })) })));
};
export default BuyFormNew;
